module.exports = __webpack_public_path__ + "static/media/tutorial-card-1.6d336901.png";